module.exports = __webpack_public_path__ + "img/dusk.d34bdfb5.png";